// cspell:ignore pgsql, protobuf
export const LANGUAGES = {
    angular: 'Angular',
    // eslint-disable-next-line id-length
    c: 'C',
    clojure: 'Clojure',
    cmake: 'CMake',
    coffeescript: 'CoffeeScript',
    commonLisp: 'Common Lisp',
    cpp: 'C++',
    crystal: 'Crystal',
    csharp: 'C#',
    css: 'CSS',
    cypher: 'Cypher',
    // eslint-disable-next-line id-length
    d: 'D',
    dart: 'Dart',
    diff: 'Diff',
    dockerfile: 'Dockerfile',
    ebnf: 'EBNF',
    elm: 'Elm',
    erlang: 'Erlang',
    gherkin: 'Gherkin',
    go: 'Go',
    groovy: 'Groovy',
    haskell: 'Haskell',
    haxe: 'Haxe',
    html: 'HTML',
    java: 'Java',
    javascript: 'JavaScript',
    json: 'JSON',
    jsx: 'JSX',
    julia: 'Julia',
    kotlin: 'Kotlin',
    less: 'Less',
    liquid: 'Liquid',
    lua: 'Lua',
    markdown: 'Markdown',
    mathematica: 'Mathematica',
    mermaid: 'Mermaid',
    nginx: 'Nginx',
    objectiveC: 'Objective-C',
    objectiveCpp: 'Objective-C++',
    pascal: 'Pascal',
    perl: 'Perl',
    pgsql: 'PGSQL',
    php: 'PHP',
    powershell: 'PowerShell',
    protobuf: 'Protobuf',
    python: 'Python',
    // eslint-disable-next-line id-length
    r: 'R',
    ruby: 'Ruby',
    rust: 'Rust',
    sass: 'Sass',
    scala: 'Scala',
    scheme: 'Scheme',
    shell: 'Shell',
    solidity: 'Solidity',
    sql: 'SQL',
    stylus: 'Stylus',
    svelte: 'Svelte',
    swift: 'Swift',
    toml: 'TOML',
    tsx: 'TSX',
    typescript: 'TypeScript',
    vue: 'Vue',
    xml: 'XML',
    yaml: 'YAML',
};
//# sourceMappingURL=constants.js.map